import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSpecialistByID, getSpecialistBySlug } from '../../api/specialist/specialist';
import { RootState } from '..';
import { getMatchingValues } from 'src/shared/utils/specialist';
import { fetchLastContractBySpecialistId } from 'src/api/contracts';

export const fetchSpecialistByID = createAsyncThunk(
  'loadedSpecialists/fetchSpecialistByID',
  async (id: string, thunkAPI) => {
    const { specialists } = thunkAPI.getState() as RootState;
    const response = await getSpecialistByID(id);
    return { ...response, ...getMatchingValues(specialists?.filters.values, response) };
  }
);

export const fetchLastContract = createAsyncThunk('loadedSpecialists/fetchLastContract', async (id: string) => {
  const response = await fetchLastContractBySpecialistId(id);
  return response;
});

export const fetchSpecialistBySlug = createAsyncThunk(
  'loadedSpecialists/fetchSpecialistBySlug',
  async (slug: string, thunkAPI) => {
    const { specialists } = thunkAPI.getState() as RootState;

    const response = await getSpecialistBySlug(slug);
    return { ...response, ...getMatchingValues(specialists?.filters.values, response) };
  }
);
